<hw-page-header header="term.cs-04.header" class="page-header" (onBack)="goBack()">
  <div class="content float-right">
    <button (click)="save()" class="float-right" nz-button nzType="primary">
      {{ 'core.btn.save' | translate }}
    </button>
  </div>
</hw-page-header>

<nz-content class="page-content">
  <div class="page-content__container">
    <form nz-form #form="ngForm" *ngIf="codeSystem">
      <hw-form-row>
        <div *hw-form-col>
          <hw-form-item name="code" [required]="true" label="term.cs-04.id">
            <input nz-input name="code" [(ngModel)]="concept.code" required />
          </hw-form-item>
        </div>
      </hw-form-row>
      <hw-form-row *ngIf="!hidden['names']">
        <div *hw-form-col>
          <hw-form-item name="names" label="term.cs-04.names">
            <hw-multilang-input name="names" [(ngModel)]="concept.names"></hw-multilang-input>
          </hw-form-item>
        </div>
      </hw-form-row>
      <hw-form-row *ngIf="!hidden['parent']">
        <div *hw-form-col>
          <hw-form-item name="parent" label="term.cs-04.parent">
            <hw-term-codesystem-concept-tree-select
              name="parent"
              [(ngModel)]="concept.parent"
              [codesystem]="codeSystem.id"
              [exclude]="concept.code">
            </hw-term-codesystem-concept-tree-select>
          </hw-form-item>
        </div>
      </hw-form-row>
      <hw-form-row *ngIf="!hidden['validFrom']">
        <div *hw-form-col>
          <hw-form-item name="validFrom" label="term.cs-04.valid-from">
            <hw-date-picker name="validFrom" [(ngModel)]="concept.valid.lower"></hw-date-picker>
          </hw-form-item>
        </div>
      </hw-form-row>
      <hw-form-row *ngIf="!hidden['validTo']">
        <div *hw-form-col>
          <hw-form-item name="validTo" label="term.cs-04.valid-to">
            <hw-date-picker name="validTo" [(ngModel)]="concept.valid.upper"></hw-date-picker>
          </hw-form-item>
        </div>
      </hw-form-row>

      <nz-divider nzText="{{ 'term.cs-04.attributes' | translate }}" nzOrientation="left"></nz-divider>
      <hw-form-row *ngFor="let attr of codeSystem.attributes">
        <div *hw-form-col>
          <hw-form-item name="attr{{ attr.id }}" label="{{ attr.names | localName : attr.id }}">
            <hw-term-attribute-input
              name="attr{{ attr.id }}"
              [(ngModel)]="concept.attributes[attr.id]"
              [attribute]="attr"
            ></hw-term-attribute-input>
          </hw-form-item>
        </div>
      </hw-form-row>
    </form>
  </div>
</nz-content>
